import type { ColumnDef } from '@tanstack/react-table';

import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { PointsRequestData } from '@/services/pointsRequest/pointsRequest.types';
import { useDynamicLocale } from '@/hoslog-intl';

export function getColumns(t: ReturnType<typeof useDynamicLocale>['t']): ColumnDef<PointsRequestData>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.sn')} />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[10rem]">{row.getValue('sn')}</div>,
      enableSorting: false,
    },
    {
      accessorKey: 'requestID',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Request ID" />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[20rem]">{row.getValue('requestID')}</div>,
      meta: {
        label: 'Request ID',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'requestedDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Requested Date" />,
      cell: ({ row }) => <div>{row.getValue('requestedDate')}</div>,
      meta: {
        label: 'Requested Date',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'clubInfo',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Club Info" />,
      cell: ({ row }) => <div>{row.getValue('clubInfo')}</div>,
      meta: {
        label: 'Club Info',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'paymentMethod',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('common.page.tableColumn.paymentMethod')} />
      ),
      cell: ({ row }) => <div>{row.getValue('paymentMethod')}</div>,
      meta: {
        label: t('common.page.tableColumn.paymentMethod'),
      },
      enableHiding: false,
    },
    {
      accessorKey: 'amountTransferred',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Amount Transferred" />,
      cell: ({ row }) => <div>{row.getValue('amountTransferred')}</div>,
      meta: {
        label: 'Amount Transferred',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'status',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.status')} />,
      cell: ({ row }) => <div>{row.getValue('status')}</div>,
      meta: {
        label: 'Status',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'updatedBy',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Updated By" />,
      cell: ({ row }) => <div>{row.getValue('updatedBy')}</div>,
      meta: {
        label: 'Updated By',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'updatedDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Updated Date" />,
      cell: ({ row }) => <div>{row.getValue('updatedDate')}</div>,
      meta: {
        label: 'Updated Date',
      },
      enableHiding: false,
    },

    {
      id: 'actions',
      accessorKey: 'Actions',
      cell: () => (
        <div className="flex gap-3">
          <button
            type="button"
            className="border border-destructive text-destructive-text py-2 px-3 font-bold text-fine rounded-sm cursor-pointer"
          >
            Reject
          </button>
          <button
            type="button"
            className="bg-success py-2 px-3 font-bold text-fine rounded-sm text-background cursor-pointer"
          >
            Approve
          </button>
        </div>
      ),
      size: 40,
    },
  ];
}
